<template>
    <Card :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`" :modifiers="`py-5`">
        <template slot="card-header">
            <h1 v-translate>Password Restored!</h1>
        </template>
        <template slot="card-body">
            <div class="form-group row justify-content-center mb-0">
                <div class="col-md-6 text-center">
                    <router-link to="/" class="btn btn-primary btn--2x" v-translate>Return To Login</router-link>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import Card from '@C/Card.vue';
export default {
    name: 'PasswordResetSuccess',
    components: {
        Card
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/PasswordResetSuccess.vue